<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("document sign module settings") }}
      </h1>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("drive module integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_integrate_drive_product"
            name="chk_integrate_drive"
            v-model="meta.integrate_drive"
          />
          <label for="chk_integrate_drive_product">{{ $t("integrate") }}</label>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('drive for built pdf documents')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/drive/catalog"
            name_field="name"
            value_field="drive_id"
            @selected="drive_changed"
            ref="drive_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('drive for signatures')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/drive/catalog"
            name_field="name"
            value_field="drive_id"
            @selected="drive_signatures_changed"
            ref="drive_signatures_dropdown"
          />
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('drive for logos')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/drive/catalog"
            name_field="name"
            value_field="drive_id"
            @selected="drive_logos_changed"
            ref="drive_logos_dropdown"
          />
        </div>
      </div>
    </div>

    <!-- <h1 class="title is-5">{{ $t("disclaimers") }}</h1>
    <div class="field">
      <label class="label">{{ $t("disclaimer for reject document") }}</label>
      <textarea class="textarea" v-model="meta.disclaimer_reject" rows="2">
      </textarea>
    </div>
    <div class="field">
      <label class="label">{{ $t("disclaimer for sign document") }}</label>
      <textarea class="textarea" v-model="meta.disclaimer_sign" rows="2">
      </textarea>
    </div> -->

    <!-- <h1 class="title is-5 mt-5">{{ $t("redirection") }}</h1>
    <div class="field">
      <label class="label">{{
        $t("url to redirect on document reject")
      }}</label>
      <input class="input" type="text" v-model="meta.redirect_url_reject" />
    </div>
    <div class="field">
      <label class="label">{{ $t("url to redirect on document sign") }}</label>
      <input class="input" type="text" v-model="meta.redirect_url_sign" />
    </div> -->

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  post,
  error_message,
  success_message,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "Document_signatureSettings",
  components: { GenericDropdown },
  data() {
    return {
      meta: {},
    };
  },
  methods: {
    save() {
      let v = this;
      let data = v.meta;
      v.$root.loader(true);
      save_configuration(this, data)
        .then((response) => {
          console.log("configuration saved", response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => v.$root.loader(false));
    },
    drive_changed(drive) {
      // console.log("drive changed", drive);
      let v = this;
      v.meta.drive_id = drive.drive_id;
    },
    drive_signatures_changed(drive) {
      let v = this;
      v.meta.drive_signatures_id = drive.drive_id;
    },
    drive_logos_changed(drive) {
      let v = this;
      v.meta.logo_drive_id = drive.drive_id;
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf) {
          v.meta = conf;
          if (conf.drive_id) v.$refs.drive_dropdown.set_value(conf.drive_id);
          if (conf.drive_signatures_id)
            v.$refs.drive_signatures_dropdown.set_value(
              conf.drive_signatures_id
            );
          if (conf.logo_drive_id)
            v.$refs.drive_logos_dropdown.set_value(conf.logo_drive_id);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => v.$root.loader(false));
  },
};
</script>

<style></style>
